import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseResult } from 'src/app/services/showtime-api/response.structure';
import { ShowTimeApiService } from 'src/app/services/showtime-api/showtime-api.service';
import { AlertService } from 'src/app/modules/alert/components/services/alert.service';
import { MetadataService } from '../metadata/metadata.service';

@Injectable({
  providedIn: 'root',
})
export class ConsentService extends ShowTimeApiService {
  constructor(
    protected http: HttpClient,
    protected messageService: AlertService,
    private metadata: MetadataService,
  ) {
    super(messageService);
  }

  /**
   * Accept HIPAA consent
   * POST /Consent/V1/ConsentStatus
   */
  acceptHipaaConsent(): Observable<ResponseResult> {
    const body = {
      consentStatus: true,
      consentType: 'hipaa',
    };

    return this.http
      .post<ResponseResult>(`${this.metadata.instanceInfo.restUrl}/Consent/V1/ConsentStatus`, body)
      .pipe(this.showError());
  }

  /**
   * Decline HIPAA consent
   * POST /Consent/V1/ConsentStatus
   */
  declineHipaaConsent(): Observable<ResponseResult> {
    const body = {
      consentStatus: false,
      consentType: 'hipaa',
    };

    return this.http
      .post<ResponseResult>(`${this.metadata.instanceInfo.restUrl}/Consent/V1/ConsentStatus`, body)
      .pipe(this.showError());
  }
}
